export const COMMERCES_PAGE = {
  title: "Commerces, Artisans, Services, Entreprises",
  eyebrow: "Vie locale",
  description:
    "Retrouvez les commerces, artisans et services de proximité de la commune.",
  heroImageUrl:
    "https://i0.wp.com/lechommerces.fr/wp-content/uploads/2024/09/Caisse-enregistreuse-magasin-1.jpg?fit=758%2C506&ssl=1",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Commerces, Artisans, Services, Entreprises" },
  ],
};

export const COMMERCES_SORT_OPTIONS = [
  { value: "title", label: "Nom du commerce" },
  { value: "category", label: "Catégorie" },
  { value: "city", label: "Ville" },
  { value: "distance", label: "Distance" },
];

export const COMMERCES_DIR_OPTIONS = [
  { value: "ASC", label: "Ascendant" },
  { value: "DESC", label: "Descendant" },
];